import type {
  AnalyticsItemClickProviderProps,
  AnalyticsItemPositionProviderProps,
} from './interfaces';
import { AnalyticsItemClickContext, AnalyticsItemPositionContext } from '.';

export const AnalyticsItemClickProvider = ({
  onItemClick,
  children,
}: AnalyticsItemClickProviderProps) => (
  <AnalyticsItemClickContext.Provider value={onItemClick}>
    {children}
  </AnalyticsItemClickContext.Provider>
);

export const AnalyticsItemPositionProvider = ({
  position,
  children,
}: AnalyticsItemPositionProviderProps) => (
  <AnalyticsItemPositionContext.Provider value={position}>
    {children}
  </AnalyticsItemPositionContext.Provider>
);
